import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { accountsSelectors } from 'app-components/flux/accounts';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';

import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import StdDialogForm from 'components/Dialogs/StdDialogForm';

const ExistingInstitutionLogin = ({ institutionLogin }) => {
  const accounts = useSelector((state) =>
    accountsSelectors.getAccountsForInstitutionLoginId(state, { institutionLoginId: institutionLogin.id }),
  );

  return (
    <Box display='flex' flex='1' flexDirection='column' key={institutionLogin.id}>
      <FormControlLabel value={institutionLogin} control={<Radio />} label={institutionLogin.name} />
      <Box display='flex' mt={-2} mx={3} px={1} py={0.5}>
        <Typography variant='captionRegular' color='textPrimary'>
          {`Linked Accounts: ${accounts && accounts.map((account) => ` ${account && account.name}`).toArray()}`}
        </Typography>
      </Box>
    </Box>
  );
};

const ExistingLoginPicker = (props) => {
  const { existingLoginsAtInstitution, fiBrandingIndent, onSelect } = props;
  const [value, setValue] = useState();

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSelect(value);
  };

  return (
    <StdDialogForm>
      <StdDialogContent sx={{ pl: `${fiBrandingIndent}px` }}>
        <Typography variant='titleMedium'>Select which existing connection you&apos;d like to update.</Typography>
        <FormControl component='fieldset'>
          <RadioGroup aria-label='existing_connection' name='connection' onChange={handleRadioChange}>
            {existingLoginsAtInstitution.map((institutionLogin) => (
              <ExistingInstitutionLogin institutionLogin={institutionLogin} />
            ))}
          </RadioGroup>
        </FormControl>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          children: 'Continue',
          disabled: !value,
          onClick: handleSubmit,
        }}
      />
    </StdDialogForm>
  );
};

export default ExistingLoginPicker;
